import React from 'react'
import { useSelector } from 'react-redux'
import { domain } from '../../../config/App'


const Feedback = () => {
    const { user } = useSelector(state => state.appReducer)

    React.useEffect(() => {
        if(user.email) {
            window.uj.init('cmksl9zsh028m16mlr7nzy4a4', {
                widget: true,
                trigger: 'custom',
                locale: 'pt-BR'
            })
            

            window.uj.identify({
                id: user.id,
                email: user.email,
                signature: user.signature,
                lastName: domain
            });
        }
    }, [user])

    return (
        <>
        </>
    )
}

export default Feedback